<script>
import moment from "@/utils/moment";

import Payment from "./Payment/Index";
import Wirecard from "./Wirecard";
import Success from "./Success";
import Error from "./Error";
import CantPay from "./CantPayCycle";

import cycleState from "@/utils/states/cycle";

import { mapActions } from "vuex";

export default {
  components: {
    Payment,
    Wirecard,
    Success,
    Error,
    CantPay
  },

  data() {
    return {
      cycle: null,
      paymentCallback: false
    };
  },

  methods: {
    ...mapActions("cycles", ["getCycle"]),

    setPaymentCallback(callback) {
      if (callback === "clear") return (this.paymentCallback = false);
      this.paymentCallback = callback ? "success" : "error";
    },

    async setCycle() {
      try {
        this.cycle = await this.getCycle(this.$route.params.cycle_id);
      } catch (e) {}
    },

    isIncapableToPay() {
      return !cycleState.isAbleToPay(this.cycle);
    },

    reasonForInabilityToPay() {
      let isntInPaymentStatus = !cycleState.isInPaymentStatus(
        this.cycle.status
      );
      let isntBeforeLastPaymentDay = !cycleState.isBeforeLastPaymentDay(
        this.cycle.starts_at
      );
      return isntInPaymentStatus
        ? "status"
        : isntBeforeLastPaymentDay
          ? "day"
          : false;
    }
  },

  mounted() {
    this.setCycle();
  }
};
</script>

<template>
  <div v-if="cycle">
    <div class="container">
      <div class="row">
        <div class="left holder">
          <div class="card">
            <transition name="zoom" mode="out-in">
              <cant-pay v-if="isIncapableToPay()" :cycle="cycle" :reason="reasonForInabilityToPay()" />
              <payment
                v-else-if="!paymentCallback"
                @paymentCallback="setPaymentCallback"
                @refresh="setCycle"
                :payable="cycle"
              />
              <success v-else-if="paymentCallback === 'success'" :payable="cycle" />
              <error v-else-if="paymentCallback === 'error'" @clear="setPaymentCallback('clear')" />
            </transition>
          </div>
        </div>

        <div class="right holder">
          <Wirecard />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.left {
  width: 70%;
  margin-right: 10px;
}

.right {
  width: calc(30% - 10px);
}

@media (max-width: 992px) {
  .left,
  .right {
    width: 100%;
  }

  .row {
    flex-direction: column !important;
  }
}

@media (max-width: 540px) {
  .right {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Cycle.vue